import Component from '@glimmer/component';
import { variation } from 'ember-launch-darkly';
import { t } from 'ember-intl';
import { uppercase } from 'ember-cli-string-helpers';
import {
  HdsPageHeader,
  HdsTextCode,
  HdsCopySnippet,
  HdsButton,
  HdsCardContainer,
  HdsTextDisplay,
  HdsTextBody,
  HdsLinkInline,
  HdsLinkStandalone,
} from '@hashicorp/design-system-components/components';
import { CoreLayoutMain, BreadcrumbsContainer, Flex } from 'core/components';
import linkToTfcResource from 'core/helpers/link-to-tfc-resource';
import { boxMargin, boxPadding } from 'core/modifiers';

export default class PageTerraformWorkspacesDetail extends Component {
  <template>
    <CoreLayoutMain>
      <:header>
        <HdsPageHeader as |PH|>
          <PH.Title data-test-tf-workspaces-detail-title>
            {{@workspace.displayName}}
          </PH.Title>
          <PH.Breadcrumb>
            <BreadcrumbsContainer />
          </PH.Breadcrumb>
          <PH.Description>
            <Flex @direction="column">
              <Flex
                @alignItems="center"
                @direction="row"
                data-test-tf-workspaces-detail-resourceId
              >
                <HdsTextCode>
                  {{t
                    "components.page.terraform.workspaces.detail.id-copy-snippet"
                  }}:
                </HdsTextCode>
                <HdsCopySnippet @textToCopy={{@workspace.resourceId}} />
              </Flex>
              {{#if @workspace.geo}}
                <HdsTextCode data-test-tf-workspaces-detail-resourceGeo>
                  <Flex @alignItems="center" @direction="row">
                    {{t "components.page.terraform.workspaces.detail.region"}}:
                    {{uppercase @workspace.geo}}
                  </Flex>
                </HdsTextCode>
              {{/if}}
            </Flex>
          </PH.Description>
          {{#if (variation "hcp-tfc-deep-linking")}}
            <PH.Actions>
              <HdsButton
                @icon="external-link"
                @iconPosition="trailing"
                @href={{linkToTfcResource
                  @workspace.geo
                  "hashicorp.terraform.workspace"
                  @organizationId
                  @projectId
                  @workspace.resourceId
                }}
                @isHrefExternal={{true}}
                @text={{t
                  "components.page.terraform.workspaces.detail.options.view-in-terraform"
                }}
                data-test-tf-workspaces-detail-manage-workspace-view-in-terraform-btn
              />
            </PH.Actions>
          {{/if}}
        </HdsPageHeader>
      </:header>
      <:body>
        <div class="terraform-workspace-detail">
          <div class="row--1">
            <HdsCardContainer
              @level="mid"
              @hasBorder="true"
              class="terraform__role-assignments-card"
              {{boxPadding "lg"}}
              data-test-tf-workspaces-detail-role-assignments-card
            >
              <Flex @direction="column" @justifyContent="space-between">
                <Flex
                  @direction="column"
                  @gap="md"
                  class="terraform__role-assignments-card-body"
                >
                  <HdsTextDisplay @tag="h4" @size="300" @color="primary">
                    {{t
                      "components.page.terraform.workspaces.detail.cards.role-assignments.title"
                    }}
                  </HdsTextDisplay>
                  <HdsTextBody @tag="p" @size="200" @color="primary">
                    {{t
                      "components.page.terraform.workspaces.detail.cards.role-assignments.text"
                    }}
                    <br />
                    {{t
                      "components.page.terraform.workspaces.detail.cards.role-assignments.sub-text"
                    }}
                    <HdsLinkInline
                      @href="https://developer.hashicorp.com/hcp/docs/hcp/iam/access-management"
                    >
                      {{t
                        "components.page.terraform.workspaces.detail.cards.role-assignments.learn-more"
                      }}
                    </HdsLinkInline>
                  </HdsTextBody>
                </Flex>
                <HdsLinkStandalone
                  @icon="arrow-right"
                  @iconPosition="trailing"
                  @text={{t
                    "components.page.terraform.workspaces.detail.cards.role-assignments.link-text"
                  }}
                  @route="terraform.workspaces.detail.role-assignments"
                  {{boxMargin "md 0 0 0"}}
                  data-test-tf-workspaces-detail-role-assignments-card-link
                />
              </Flex>
            </HdsCardContainer>
            {{#if (variation "hcp-tfc-deep-linking")}}
              <HdsCardContainer
                @level="mid"
                @hasBorder="true"
                class="terraform__manage-workspace-card"
                {{boxPadding "lg"}}
                data-test-tf-workspaces-detail-manage-workspace-card
              >
                <Flex @direction="column" @justifyContent="space-between">
                  <Flex
                    @direction="column"
                    @gap="md"
                    class="terraform__manage-workspace-card-body"
                  >
                    <HdsTextDisplay @tag="h4" @size="300" @color="primary">
                      {{t
                        "components.page.terraform.workspaces.detail.cards.manage-workspace.title"
                      }}
                    </HdsTextDisplay>
                    <HdsTextBody @tag="p" @size="200" @color="primary">
                      {{t
                        "components.page.terraform.workspaces.detail.cards.manage-workspace.text"
                      }}
                    </HdsTextBody>
                  </Flex>
                  <HdsLinkStandalone
                    @icon="external-link"
                    @iconPosition="trailing"
                    @text={{t
                      "components.page.terraform.workspaces.detail.cards.manage-workspace.link-text"
                    }}
                    @href={{linkToTfcResource
                      @workspace.geo
                      "hashicorp.terraform.workspace"
                      @organizationId
                      @projectId
                      @workspace.resourceId
                    }}
                    @isHrefExternal={{true}}
                    {{boxMargin "md 0 0 0"}}
                    data-test-tf-workspaces-detail-manage-workspace-card-link
                  />
                </Flex>
              </HdsCardContainer>
            {{/if}}
          </div>
        </div>
      </:body>
    </CoreLayoutMain>
  </template>
}
